function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 7,
  d: "M120.539 388.946h336.492"
}), /*#__PURE__*/React.createElement("path", {
  d: "M173.654 256.48c66.389 17.788 123.256 20.832 127.017 6.798 3.76-14.035-47.01-39.832-113.399-57.621l-13.618 50.823",
  fill: "#000"
}), /*#__PURE__*/React.createElement("path", {
  d: "M173.654 256.48c66.389 17.788 123.256 20.832 127.017 6.798 3.76-14.035-47.01-39.832-113.399-57.621l-13.618 50.823",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 7
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M200.91 374.801h.309v11.783h-.309z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 7,
  d: "M200.91 374.801h.309v11.783h-.309z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M180.171 388.946c0-15.899 18.364-28.787 41.017-28.787 22.653 0 41.017 12.888 41.017 28.787h-82.034",
  fill: "#797979"
}), /*#__PURE__*/React.createElement("path", {
  d: "M180.171 388.946c0-15.899 18.364-28.787 41.017-28.787 22.653 0 41.017 12.888 41.017 28.787h-82.034",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 7
}), /*#__PURE__*/React.createElement("path", {
  d: "M160.048 388.946c0-15.899 18.364-28.787 41.017-28.787 22.653 0 41.017 12.888 41.017 28.787h-82.034",
  fill: "#797979"
}), /*#__PURE__*/React.createElement("path", {
  d: "M160.048 388.946c0-15.899 18.364-28.787 41.017-28.787 22.653 0 41.017 12.888 41.017 28.787h-82.034",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 7
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 201.065,
  cy: 274.024,
  rx: 79.18,
  ry: 101.897,
  fill: "#000"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 201.065,
  cy: 274.024,
  rx: 79.18,
  ry: 101.897,
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 7
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 235.027,
  cy: 271.817,
  rx: 41.017,
  ry: 74.981,
  fill: "#fff"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 235.027,
  cy: 271.817,
  rx: 41.017,
  ry: 74.981,
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 7
}), /*#__PURE__*/React.createElement("path", {
  d: "M242.337 143.504c22.684 12.714 24.297 35.785 3.604 51.531-20.694 15.747-55.858 18.206-78.542 5.493-22.684-12.714-24.297-35.785-3.604-51.531 20.694-15.747 55.858-18.206 78.542-5.493",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M242.337 143.504c22.684 12.714 24.297 35.785 3.604 51.531-20.694 15.747-55.858 18.206-78.542 5.493-22.684-12.714-24.297-35.785-3.604-51.531 20.694-15.747 55.858-18.206 78.542-5.493",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 7
}), /*#__PURE__*/React.createElement("path", {
  d: "M201.074 159.491c2.565 2.127 2.825 5.848.581 8.312-2.244 2.463-6.142 2.736-8.707.609-2.565-2.127-2.825-5.849-.581-8.312 2.244-2.463 6.142-2.736 8.707-.609",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M201.074 159.491c2.565 2.127 2.825 5.848.581 8.312-2.244 2.463-6.142 2.736-8.707.609-2.565-2.127-2.825-5.849-.581-8.312 2.244-2.463 6.142-2.736 8.707-.609",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 7
}), /*#__PURE__*/React.createElement("path", {
  d: "M134.417 254.048c76.171 43.977 143.809 69.427 151.073 56.844 7.265-12.583-48.594-58.433-124.765-102.41l-26.308 45.566",
  fill: "#000"
}), /*#__PURE__*/React.createElement("path", {
  d: "M134.417 254.048c76.171 43.977 143.809 69.427 151.073 56.844 7.265-12.583-48.594-58.433-124.765-102.41l-26.308 45.566",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 7
}), /*#__PURE__*/React.createElement("path", {
  d: "M93.009 141.646c.8 18.526 35.795-.987 35.795-.987s-36.596-17.538-35.795.987z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M93.009 141.646c.8 18.526 35.795-.987 35.795-.987s-36.596-17.538-35.795.987z",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 7
}), /*#__PURE__*/React.createElement("path", {
  d: "M130.845 88.176c-15.287 10.496 19.806 29.833 19.806 29.833s-4.52-40.33-19.806-29.833z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M130.845 88.176c-15.287 10.496 19.806 29.833 19.806 29.833s-4.52-40.33-19.806-29.833z",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 7
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M391.184 274.396c-66.39-17.789-117.16-43.586-113.399-57.62 3.76-14.035 60.628-10.991 127.016 6.797l-13.617 50.823",
  fill: "#000"
}), /*#__PURE__*/React.createElement("path", {
  d: "M391.184 274.396c-66.39-17.789-117.16-43.586-113.399-57.62 3.76-14.035 60.628-10.991 127.016 6.797l-13.617 50.823",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 7
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M377.696 374.801h.309v11.783h-.309z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 7,
  d: "M377.696 374.801h.309v11.783h-.309z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M398.744 388.946c0-15.899-18.364-28.787-41.017-28.787-22.653 0-41.017 12.888-41.017 28.787h82.034",
  fill: "#797979"
}), /*#__PURE__*/React.createElement("path", {
  d: "M398.744 388.946c0-15.899-18.364-28.787-41.017-28.787-22.653 0-41.017 12.888-41.017 28.787h82.034",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 7
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M418.869 388.946c0-15.899-18.364-28.787-41.017-28.787-22.653 0-41.017 12.888-41.017 28.787h82.034",
  fill: "#797979"
}), /*#__PURE__*/React.createElement("path", {
  d: "M418.869 388.946c0-15.899-18.364-28.787-41.017-28.787-22.653 0-41.017 12.888-41.017 28.787h82.034",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 7
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
  cx: 377.851,
  cy: 274.024,
  rx: 79.18,
  ry: 101.897,
  fill: "#000"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 377.851,
  cy: 274.024,
  rx: 79.18,
  ry: 101.897,
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 7
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
  cx: 343.889,
  cy: 271.817,
  rx: 41.017,
  ry: 74.981,
  fill: "#fff"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 343.889,
  cy: 271.817,
  rx: 41.017,
  ry: 74.981,
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 7
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M345.616 137.504c-25.201 6.41-32.731 28.277-16.818 48.843 15.913 20.565 49.243 32.042 74.444 25.633 25.201-6.41 32.731-28.277 16.818-48.843-15.913-20.566-49.243-32.042-74.444-25.633",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M345.616 137.504c-25.201 6.41-32.731 28.277-16.818 48.843 15.913 20.565 49.243 32.042 74.444 25.633 25.201-6.41 32.731-28.277 16.818-48.843-15.913-20.566-49.243-32.042-74.444-25.633",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 7
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M381.336 163.626c-3.028 1.39-4.243 4.917-2.713 7.877 1.53 2.96 5.225 4.233 8.253 2.842 3.028-1.39 4.243-4.917 2.713-7.878-1.53-2.96-5.225-4.232-8.253-2.841",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M381.336 163.626c-3.028 1.39-4.243 4.917-2.713 7.877 1.53 2.96 5.225 4.233 8.253 2.842 3.028-1.39 4.243-4.917 2.713-7.878-1.53-2.96-5.225-4.232-8.253-2.841",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 7
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M444.497 254.047c-76.17 43.977-143.808 69.427-151.073 56.844-7.264-12.583 48.595-58.433 124.765-102.41l26.308 45.566",
  fill: "#000"
}), /*#__PURE__*/React.createElement("path", {
  d: "M444.497 254.047c-76.17 43.977-143.808 69.427-151.073 56.844-7.264-12.583 48.595-58.433 124.765-102.41l26.308 45.566",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 7
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M264.254 158.954c18.597 5.575 21.051 19.497 5.483 31.096-15.57 11.599-43.266 16.483-61.863 10.908-18.597-5.575-21.051-19.497-5.483-31.096 15.57-11.599 43.266-16.482 61.863-10.908",
  fill: "#797979"
}), /*#__PURE__*/React.createElement("path", {
  d: "M264.254 158.954c18.597 5.575 21.051 19.497 5.483 31.096-15.57 11.599-43.266 16.483-61.863 10.908-18.597-5.575-21.051-19.497-5.483-31.096 15.57-11.599 43.266-16.482 61.863-10.908",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 7
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 7,
  d: "M194.496 187.958l83.359-14.698"
}))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M376.255 173.197c14.499 12.912 10.84 26.567-8.172 30.5-19.012 3.932-46.178-3.347-60.676-16.258-14.499-12.912-10.84-26.567 8.172-30.5 19.012-3.932 46.178 3.347 60.676 16.258",
  fill: "#797979"
}), /*#__PURE__*/React.createElement("path", {
  d: "M376.255 173.197c14.499 12.912 10.84 26.567-8.172 30.5-19.012 3.932-46.178-3.347-60.676-16.258-14.499-12.912-10.84-26.567 8.172-30.5 19.012-3.932 46.178 3.347 60.676 16.258",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 7
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 7,
  d: "M300.776 170.002l81.762 21.908"
}))));

var SvgSocial = function SvgSocial(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "89.496 82.933 371.035 310.513"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/social.8e82e972.svg";
export { SvgSocial as ReactComponent };